<script>
import { mapGetters } from 'vuex';
import MentionBox from '../mentions/MentionBox.vue';

export default {
  components: { MentionBox },
  props: {
    searchKey: {
      type: String,
      default: '',
    },
  },
  emits: ['replace'],
  computed: {
    ...mapGetters({
      cannedMessages: 'getCannedResponses',
      currentUser: 'getCurrentUser', // GK-HUB: get agent for team lookup
      agentList: 'agents/getAgents', // GK-HUB: agents list has team_ids
    }),
    // GK-HUB: team_ids from current agent (agents store has team_ids from jbuilder)
    agentTeamIds() {
      const agentRecord = this.agentList?.find(
        a => a.id === this.currentUser?.id
      );
      return agentRecord?.team_ids || [];
    },
    items() {
      return this.cannedMessages.map(cannedMessage => ({
        label: cannedMessage.short_code,
        key: cannedMessage.short_code,
        description: cannedMessage.content,
      }));
    },
  },
  watch: {
    searchKey() {
      this.fetchCannedResponses();
    },
  },
  mounted() {
    this.fetchCannedResponses();
  },
  methods: {
    fetchCannedResponses() {
      // GK-HUB: pass agent's team_ids to filter canned responses
      // Agent sees responses from their teams + globals
      this.$store.dispatch('getCannedResponse', {
        searchKey: this.searchKey,
        teamIds: this.agentTeamIds,
      });
    },
    handleMentionClick(item = {}) {
      this.$emit('replace', item.description);
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <MentionBox
    v-if="items.length"
    :items="items"
    @mention-select="handleMentionClick"
  />
</template>
